
import {Component, Vue} from 'vue-property-decorator'
import { VStepperItems } from 'vuetify/lib'

@Component({
  name: 'StepperItems',
  extends: VStepperItems as any,
})
export default class StepperItems extends Vue {
}
